module.exports = __webpack_public_path__ + "static/media/Bicocca - white_Peri.85e32742.jpg";